var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "eisl6vfrwa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D00245",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D64D00",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12zm0-22.08c5.558 0 10.08 4.522 10.08 10.08S17.558 22.08 12 22.08 1.92 17.558 1.92 12 6.442 1.92 12 1.92zm4.35 13.2H13.44c.204.358.306.766.357 1.226.205 1.175-.715 2.197-1.89 2.197H11.6a.44.44 0 0 1-.41-.409v-1.226c0-.97-.51-1.89-1.378-2.401V8.121l.408-.306c.307-.205.664-.358 1.022-.358h4.495c.869 0 1.584.613 1.686 1.43l.664 4.24c.205 1.022-.51 1.993-1.737 1.993zM6.644 7.815h1.328c.41 0 .767.357.767.766v5.21a.786.786 0 0 1-.767.767H6.644a.786.786 0 0 1-.766-.766v-5.21c0-.41.358-.767.766-.767z",
    fill: "url(#eisl6vfrwa)",
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.6a659e7f4b8eb93d879805590430da7b.svg";
export { ForwardRef as ReactComponent };